import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Loader, EmptyState } from "@/components/ui-kit";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { usePartnerMeta, Pill } from "@/lib/partner";
import { Sel } from "@/components/partner/PartnerDialogs";
import { Handshake } from "lucide-react";
import { toast } from "sonner";

const ALL = "__all";

export default function PartnerList() {
  const [meta] = usePartnerMeta();
  const nav = useNavigate();
  const [f, setF] = useState({});
  const [items, setItems] = useState(null);
  useEffect(() => {
    const p = Object.fromEntries(Object.entries(f).filter(([, v]) => v && v !== ALL));
    api.get("/partners", { params: p }).then((r) => setItems(r.data)).catch((e) => { toast.error(apiErr(e)); setItems([]); });
  }, [JSON.stringify(f)]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!meta || items === null) return <Loader />;
  const sel = (k, ph, opts) => <div className="w-52"><Sel value={f[k] || ALL} onChange={(v) => setF({ ...f, [k]: v })} options={[[ALL, ph], ...opts]} testid={`partner-filter-${k}`} /></div>;
  return (
    <div data-testid="partner-list">
      <PageHeader title="Tous les partenaires" subtitle={`${items.length} fiche(s) dans votre périmètre`} />
      <div className="flex flex-wrap gap-2 mb-3">
        <Input className="w-60" placeholder="Rechercher" value={f.q || ""} onChange={(e) => setF({ ...f, q: e.target.value })} data-testid="partner-search" />
        {sel("categorie", "Toutes catégories", meta.config.categories || [])}
        {sel("pipeline_id", "Tous les pipelines", meta.pipelines.map((p) => [p.id, p.nom]))}
        {sel("statut", "Statut (hors archivés)", meta.partner_statuses)}
        {sel("responsable_id", "Tous responsables", meta.users.map((u) => [u.id, u.name]))}
      </div>
      {items.length === 0 ? <EmptyState icon={Handshake} title="Aucun partenaire" subtitle="Convertissez un contact pour créer votre premier partenaire." /> : (
        <div className="rounded-xl border bg-white overflow-x-auto"><Table>
          <TableHeader><TableRow className="bg-slate-50"><TableHead>N°</TableHead><TableHead>Partenaire</TableHead><TableHead>Catégorie</TableHead><TableHead>Pipeline / étape</TableHead><TableHead>Responsable</TableHead><TableHead>Statut</TableHead></TableRow></TableHeader>
          <TableBody>{items.map((p) => (
            <TableRow key={p.id} className="cursor-pointer hover:bg-slate-50" onClick={() => nav(`/partenariat/fiche/${p.id}`)} data-testid={`partner-row-${p.id}`}>
              <TableCell className="font-mono text-xs text-brand-700">{p.numero}</TableCell>
              <TableCell className="font-medium">{p.nom}<p className="text-xs text-slate-400">{p.raison_sociale}</p></TableCell>
              <TableCell className="text-sm">{p.categorie}</TableCell>
              <TableCell className="text-xs">{p.pipeline_nom}<p className="font-semibold">{p.stage_nom}</p></TableCell>
              <TableCell className="text-sm">{p.responsable_name}</TableCell><TableCell><Pill s={p.statut} /></TableCell>
            </TableRow>))}</TableBody></Table></div>
      )}
    </div>
  );
}
